import { Alert } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { FaqPost } from '../../../services/api/websiteFaqs';
import { FaqCategory, getFaqs } from '../../../services/api/websiteFaqs';
import { ExternalLink } from '../../elements/atoms/externalLink/ExternalLink';
import { HeroText } from '../../elements/atoms/heroText/HeroText';
import { PageTitle } from '../../elements/atoms/pageTitle/PageTitle';
import { FaqItem } from '../../elements/molecules/faqItem/FaqItem';
import { PageWrapperWithHeader } from '../../elements/organisms/pageWrapper/PageWrapperWithHeader';

export function OsasFaq() {
    const contactEmail = <ExternalLink href="mailto:polikliniek@ksyos.nl">polikliniek@ksyos.nl</ExternalLink>;
    const [faqPosts, setFaqPosts] = useState<FaqPost[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        loadFaqs();
    }, []);

    if (error) {
        return (
            <PageWrapperWithHeader>
                <PageTitle>Veelgestelde vragen</PageTitle>
                <HeroText>
                    De vragen konden niet geladen worden. Probeer later nogmaals, of neem contact met ons op via{' '}
                    {contactEmail} of <ExternalLink href="tel:020-2366533">020 600 00 60</ExternalLink>.
                </HeroText>
                <Alert
                    appearance="warning"
                    withIcon
                >
                    {error}
                </Alert>
            </PageWrapperWithHeader>
        );
    }

    return (
        <PageWrapperWithHeader>
            <PageTitle>Veelgestelde vragen</PageTitle>
            <HeroText>
                Hier vind je de meest voorkomende vragen. Staat jouw vraag er niet tussen? Neem dan contact met ons op
                via {contactEmail} of <ExternalLink href="tel:020-2366533">020 600 00 60</ExternalLink>.
            </HeroText>
            {error ? (
                <div>{error}</div>
            ) : (
                <>
                    {faqPosts.map((faqPost) => (
                        <FaqItem
                            answer={faqPost.answer}
                            isHtmlAnswer={true}
                            key={faqPost.ID}
                            question={faqPost.question}
                        />
                    ))}
                </>
            )}
        </PageWrapperWithHeader>
    );

    async function loadFaqs() {
        try {
            const faqs = await getFaqs(FaqCategory.patientOsas);
            setFaqPosts(faqs.posts);
        } catch {
            setError('Er is een fout opgetreden bij het ophalen van de veelgestelde vragen.');
        }
    }
}
